/*
* Constantes de configuration pour Terrassor (et valeur temporaires pour dev)
*/

//export const CURRENT_CHANTIER_ID = 2;
export const CURRENT_ETUDE_ID = 1;
export const CURRENT_INSTALLATION_ID = 1;
export const CURRENT_ELEVE_ID = 1;

//export const CODE_CHANTIER = "4bEs";
export const NB_ECHELONS_MAX = 3;
export const NB_HEURES_PAR_JOUR = 3;

export const HAS_INSTALLATION = true;
export const MODE_DEBUG = false;
export const REQUIRED_DATABASE_VERSION = 13; // 8
export const DATABASE_NAME = 'terrassor';

export const URL_ADMIN = "https://admin.terrassor.fr"
export const URL_APPLI = "https://mon.terrassor.fr"

export const SECURITE_VALIDE = 1
export const IS_WEB = 0


export const ETAPE_EPURE_DONNEES_GENERIQUES = 0
export const ETAPE_EPURE_DONNEES_GENERIQUES_OK = 1
export const ETAPE_EPURE_CUBATURES = 2
export const ETAPE_EPURE_MOUVEMENTS = 3
export const ETAPE_SIMULATION = 4

export const MODE_EPURE = 1
export const MODE_EXAMEN = 2
export const MODE_SIMULATEUR = 0

export const MODE_UTILISATION = 0 // par défaut  MODE_UTILISATION égal à MODE_SIMULATEUR

// valeurs par défaut du chantier (car on peut rentrer dans l'appli sans chantier : mode examen et epure)
export const CHANTIER_CODE = ""
export const CHANTIER_ID = -1
export const ALEA_GROUPE_ID = 0




// WEBPACK FOOTER //
// ./src/client/terrassor_const.js